// keep things alphabelically sorted !!!
const Dictionary = Object.freeze({
  // create/edit forms
  it: {
    resources: {
      address_book: {
        status_addressbook: {
          label: "Tipo di Recapito",
        },
        attribute_MAIL_value: {
          label: "E-mail",
        },
        title: {
          label: "Descrizione",
        },
        attribute_PEC_value: {
          label: "PEC",
        },
        attribute_WEB_value: {
          label: "Sito internet",
        },
        attribute_PHON_value: {
          label: "Telefono",
        },
        attribute_CELL_value: {
          label: "Cellulare",
        },
        attribute_FAX_value: {
          label: "Fax",
        },
        attribute_SMSFROM_value: {
          label: "Mittente SMS",
        },
        attribute_SIGNMAIL_value: {
          label: "Mittente MAIL",
        },
      },
      advance_payment: {
        status: {
          label: "Stato Acconto",
        },
        total_deposit: {
          label: "Importo Acconto",
        },
        negative_deposit: {
          label: "Importo Recuperato",
        },
        diff_deposit: {
          label: "Importo Da Recuperare",
        },
      },
      agency_book: {
        opening_balance: {
          label: "Apertura Saldo",
        },
        book_date: {
          label: "Data Registrazione",
        },
        broker: {
          label: "Produttore associato",
        },
        effective_date: {
          label: "Data Effetto",
        },
        additional_description: {
          label: "Descrizione",
        },
        gross: {
          label: "Lordo",
        },
        invoice_protocol_number: {
          label: "Nr. protocollo fatture passive",
        },
        agencybook_type: {
          label: "Tipologia Movimento",
        },
        treasury_id: {
          label: "Cassa",
        },
        payment_reference_id: {
          label: "Causale",
        },
        payment_reference_code: {
          label: "Causale Movimento",
        },
      },
      agency_contact: {
        pk: {
          label: "Identificativo primario",
        },
        sk: {
          label: "Identificativo secondario",
        },
        status_agencycontact: {
          label: "Tipo Contatto",
        },
        attribute_TITL_value: {
          label: "Titolo",
        },
        title: {
          label: "Descrizione",
        },
        city: {
          label: "Città",
        },
        province: {
          label: "Provincia",
        },
        cell: {
          label: "Cellulare",
        },
        phone: {
          label: "Telefono",
        },
        email: {
          label: "Email",
        },
        attribute_SEX_value: {
          label: "Sesso",
        },
        attribute_NAME_value: {
          label: "Nome",
        },
        attribute_SURN_value: {
          label: "Cognome",
        },
        attribute_CNAM_value: {
          label: "Ragione sociale",
        },
        attribute_NINO_value: {
          label: "Codice Fiscale",
        },
        attribute_CREG_value: {
          label: "Partita IVA",
        },
        attribute_MARS_value: {
          label: "Stato civile",
        },
        attribute_PROF_value: {
          label: "Professione",
        },
        attribute_DOB_value: {
          label: "Data nascita",
        },
        attribute_POB_value: {
          label: "Luogo nascita",
        },
        attribute_POB2_value: {
          label: "Luogo nascita estero",
        },
        attribute_NOB_value: {
          label: "Nazione nascita",
        },
        attribute_NOB2_value: {
          label: "Nazione di nascita estera",
        },
        attribute_TREG_value: {
          label: "Identificativo temporaneo",
        },
        attribute_CLI_value: {
          label: "Cliente",
        },
        attribute_SUP_value: {
          label: "Fornitore",
        },
      },
      analysis: {
        name: {
          label: "Titolo",
        },
        description: {
          label: "Descrizione",
        },
        download: {
          label: "Download",
        },
        created_at: {
          label: "Creato il",
        },
        updated_at: {
          label: "Ultimo aggiornamento",
        },
      },
      attribute: {
        is_hidden: {
          label: "Visibilità",
        },
        text: {
          label: "Nome Campo",
        },
        is_searchable: {
          label: "Ricercabile",
        },
        is_sortable: {
          label: "Ordinabile",
        },
        type: {
          label: "Tipo",
        },
        section: {
          label: "Sezione",
        },
        entity: {
          label: "Entità Associata",
        },
      },
      agency_setup: {
        code: {
          label: "Codice Agenzia",
        },
        title: {
          label: "Descrizione Agenzia",
        },
        attribute_ROBR_value: {
          label: "Iscrizione RUI",
        },
        attribute_NINO_value: {
          label: "Codice Fiscale",
        },
        attribute_CREG_value: {
          label: "Partita Iva",
        },
        attribute_CNAM_value: {
          label: "Ragione Sociale",
        },
      },
      bank_account: {
        abi: {
          label: "ABI",
        },
        bank: {
          label: "Banca",
        },
        cab: {
          label: "CAB",
        },
        code: {
          label: "Code",
        },
        cuc: {
          label: "Codice Univoco CBI",
        },
        credit_account: {
          label: "Conto di accredito",
        },
        debtor_iban: {
          label: "Codice IBAN debitore",
        },
        iban: {
          label: "IBAN",
        },
        identifier: {
          label: "Creditor Identifier",
        },
        referer_type: {
          label: "Refer Type",
        },
        status_setup: {
          label: "Disabilitazione",
        },
        support: {
          label: "Nome Supporto",
        },
        title: {
          label: "Title",
        },
        use_rid: {
          label: "Utilizzo flusso RID",
        },
      },
      book_tag: {
        title: {
          label: "Descrizione",
        },
        code: {
          label: "Codice Documento",
        },
        is_system: {
          label: "Sistema",
        },
      },
      book_entry: {
        title: {
          label: "Descrizione",
        },
        registry: {
          label: "Contraente",
        },
        insurance_policy_number: {
          label: "Numero polizza",
        },
        book_date: {
          label: "Data Registrazione",
        },
        effective_date: {
          label: "Data Effetto",
        },
        sheet_date: {
          label: "Data Foglio Cassa",
        },
        sheet_number: {
          label: "Progressivo Foglio Cassa",
        },
        net: {
          label: "Imponibile",
        },
        various_accountings: {
          label: "Causale",
        },
        tax: {
          label: "Imposte",
        },
        gross: {
          label: "Lordo",
        },
        fee_gross: {
          label: "Diritti",
        },
        fee_net: {
          label: "Netto",
        },
        fee_tax: {
          label: "Tasse",
        },
        take: {
          label: "Incasso Diretto",
        },
        insurer_id: {
          label: "Compagnia",
        },
        insurance_risk: {
          label: "Codice Rischio Compagnia",
        },
        risk_branch: {
          label: "Codice Ramo Compagnia",
        },
        insurer_mandate_code: {
          label: "Codice mandato compagnia",
        },
        agency_prov_purchase: {
          label: "Provvigioni d'agenzia d'acquisto",
        },
        agency_prov_take: {
          label: "Provvigioni d'agenzia d'incasso",
        },
        saler_prov_purchase: {
          label: "Provvigioni del produttore d'acquisto",
        },
        saler_prov_take: {
          label: "Provvigioni del produttore d'incasso",
        },
        saler_fee_take: {
          label: "Diritti di incasso del produttore",
        },
        total_prov: {
          label: "Totale provvigioni",
        },
        imported_at: {
          label: "Data di Importazione",
        },
        is_taxable: {
          label: "Soggetto a Ritenuta",
        },
        broker: {
          label: "Cod. Descr. Produttore",
        },
        entry_in: {
          label: "Passivi",
        },
        entry_out: {
          label: "Attivi",
        },
        entry_in_company: {
          label: "Uscite",
        },
        entry_out_company: {
          label: "Entrate",
        },
        neg_rebate: {
          label: "Attivi",
        },
        pos_rebate: {
          label: "Passivi",
        },
        lisapay_collect: {
          label: "Recupera",
        },
      },
      breakdown: {
        title: {
          label: "Scorporo",
        },
        insurance_risk_id: {
          label: "Prodotto assicurativo",
        },
        insurer_id: {
          label: "Compagnia assicurativa",
        },
        is_net: {
          label: "È netto",
        },
        is_tax: {
          label: "È tasse",
        },
      },
      broker: {
        pk: {
          label: "Identificativo primario",
        },
        sk: {
          label: "Identificativo secondario",
        },
        status_broker: {
          label: "Tipologia",
        },
        read: {
          label: "Lettura",
        },
        write: {
          label: "Modifica",
        },
        cooperator: {
          label: "Denominazione Collaborazione",
        },
        attribute_TITL_value: {
          label: "Titolo",
        },
        title: "Status Salesman",
        attribute_SEX_value: {
          label: "Sesso",
        },
        attribute_NAME_value: {
          label: "Nome",
        },
        attribute_SURN_value: {
          label: "Cognome",
        },
        attribute_CNAM_value: {
          label: "Ragione sociale",
        },
        attribute_NINO_value: {
          label: "Codice Fiscale",
        },
        attribute_CREG_value: {
          label: "Partita IVA",
        },
        attribute_MARS_value: {
          label: "Stato civile",
        },
        attribute_PROF_value: {
          label: "Professione",
        },
        attribute_DOB_value: {
          label: "Data nascita",
        },
        attribute_POB_value: {
          label: "Luogo nascita",
        },
        attribute_POB2_value: {
          label: "Luogo nascita estero",
        },
        attribute_NOB_value: {
          label: "Nazione nascita",
        },
        attribute_NOB2_value: {
          label: "Nazione di nascita estera",
        },
        attribute_TREG_value: {
          label: "Identificativo temporaneo",
        },
        attribute_BUID_value: {
          label: "Codice univoco Lisaweb",
        },
        attribute_BAHO_value: {
          label: "Intestazione Conto Corrente",
        },
        attribute_BANK_value: {
          label: "Banca",
        },
        attribute_BABR_value: {
          label: "Filiale",
        },
        attribute_IBAN_value: {
          label: "IBAN",
        },
        attribute_ROBR_value: {
          label: "Iscrizione Rui",
        },
        attribute_WHT_value: {
          label: "% Ritenuta d'acconto",
        },
        attribute_FCPR_value: {
          label: "% Provvigione Fissa",
        },
        attribute_INNO_value: {
          label: "Nota su Fattura",
        },
        attribute_RENO_value: {
          label: "Nota su Rendiconto provvigionale",
        },
        attribute_FINO_value: {
          label: "Nota su Quietanze",
        },
        attribute_TKTP_value: {
          label: "Tipo Incasso",
        },
        attribute_REDE_value: {
          label: "Avvisi di scadenza: includi Sospesi",
        },
        attribute_SEEX_value: {
          label: "Esclusione Invio Scadenze",
        },
        attribute_REPE_value: {
          label: "Avvisi di scadenza: includi Arretrati",
        },
        attribute_READ_value: {
          label: "Avvisi di scadenza: includi Acconti",
        },
        attribute_STSA_value: {
          label: "Status Salesman",
        },
        attribute_address: {
          label: "Indirizzo",
        },
        attribute_RUI_value: {
          label: "Nr. RUI",
        },
        attribute_ritenuta_value: {
          label: "% ritenuta d'acconto",
        },
        attribute_TYPBROK_value: {
          label: "Broker",
        },
        attribute_SUBA_value: {
          label: "SUBA per PolDo",
        },
        attribute_BCONS_value: {
          label: "Consulente",
        },
        attribute_IBICONS_value: {
          label: "Intestazione Consulente",
        },
      },
      broker_statement: {
        from: {
          label: "Data dal",
        },
        to: {
          label: "Data al",
        },
        invoice_number: {
          label: "Numero polizza",
        },
        invoice_period: {
          label: "Periodo polizza",
        },
        broker_id: {
          label: "Broker",
        },
      },
      cash_entry: {
        title: {
          label: "Descrizione",
        },
        cash_time: {
          label: "Data Registrazione",
        },
        description: {
          label: "Descrizione",
        },
        gross: {
          label: "Lordo",
        },
        cash_reference_id: {
          label: "Causale",
        },
        treasury_id: {
          label: "Conto Movimentato",
        },
        broker_id: {
          label: "Produttore",
        },
        cash_entry_id: {
          label: "Conto",
        },
        entry_in: {
          label: "Entrate",
        },
        entry_out: {
          label: "Uscite",
        },
        saldo_foglio_cassa: {
          label: "Saldo Foglio Cassa",
        },
        saldo_contabilita: {
          label: "Saldo Contabilità",
        },
      },
      cash_reference: {
        title: {
          label: "Descrizione",
        },
        code: {
          label: "Causale",
        },
        default_treasury: {
          label: "Conto di Default",
        },
        reference_type: {
          label: "Tipologia Movimento",
        },
        entry_type: {
          label: "Tipologia Conto",
        },
        has_broker: {
          label: "Include Produttore",
        },
        has_company: {
          label: "Include Compagnia",
        },
        cash_reference_id: {
          label: "Causale Relazionata",
        },
        foglio_cassa_compagnia: {
          label: "Controllo Foglio Cassa Compagnia",
        },
        cassa_agenzia: {
          label: "Controllo Cassa Agenzia",
        },
      },
      claim: {
        number: {
          label: "Numero Sinistro",
        },
        claim_type: {
          label: "Tipo sinistro",
        },
        referring_at: {
          label: "Anno",
        },
        place: {
          label: "Luogo accadimento",
        },
        description: {
          label: "Descrizione accadimento",
        },
        risk_branch: {
          label: "Ramo Polizza",
        },
        occurred_at: {
          label: "Data Accadimento",
        },
        dcpd_module_type: {
          label: "CID",
        },
        driver: {
          label: "Conducente",
        },
        counterpart: {
          label: "Controparte",
        },
        insurance_policy_id: {
          label: "Polizza",
        },
        inspector: {
          label: "Ispettorato",
        },
        settled_total: {
          label: "Totale liquidato",
        },
        settlement_expense: {
          label: "Costo liquidazione sinistri",
        },
        partially_settled_at: {
          label: "Data ultima liquidazione",
        },
        deductible: {
          label: "Franchigia",
        },
        amount_in_reserve: {
          label: "Ammontare in riserva",
        },
        surveyor: {
          label: "Perito",
        },
        dcpd_module_filled: {
          label: "Compilazione CID ?",
        },
        is_covered: {
          label: "Copertura regolare",
        },
      },
      claim_party: {
        pk: {
          label: "Identificativo primario",
        },
        sk: {
          label: "Identificativo secondario",
        },
        status_claimparty: {
          label: "Tipo di Controparte",
        },
        attribute_SEX_value: {
          label: "Sesso",
        },
        attribute_FULN_value: {
          label: "Nome Completo",
        },
        attribute_NINO_value: {
          label: "Codice Fiscale",
        },
        attribute_CREG_value: {
          label: "Partita IVA",
        },
        attribute_MARS_value: {
          label: "Stato civile",
        },
        attribute_PROF_value: {
          label: "Professione",
        },
        attribute_DOB_value: {
          label: "Data nascita",
        },
        attribute_POB_value: {
          label: "Luogo nascita",
        },
        attribute_POB2_value: {
          label: "Luogo nascita estero",
        },
        attribute_NOB_value: {
          label: "Nazione nascita",
        },
        attribute_NOB2_value: {
          label: "Nazione di nascita estera",
        },
        attribute_LEGP_value: {
          label: "Persona Giuridica",
        },
        attribute_PVOB_value: {
          label: "Provincia nascita",
        },
        attribute_PROV_value: {
          label: "Provincia",
        },
      },
      commission: {
        purchase_calculation_type: {
          label: "Calcolo Acquisto",
        },
        purchase_commission: {
          label: "Provvigione",
        },
        take_calculation_type: {
          label: "Calcolo Incasso",
        },
        take_commission: {
          label: "Provvigione",
        },
      },
      consolidated_treasury: {
        insurer_id: {
          label: "Compagna",
        },
        treasury_id: {
          label: "Cassa",
        },
        gross: {
          label: "Lordo",
        },
        consolidated_at: {
          label: "Data Consolidamento",
        },
      },
      correspondence: {
        status_correspondence: {
          label: "Tipo di indirizzo",
        },
        attribute_ADDR_value: {
          label: "Indirizzo",
        },
        title: {
          label: "Descrizione",
        },
        attribute_CITY_value: {
          label: "Comune",
        },
        attribute_NAME2_value: {
          label: "Nome / Rag. soc. alternativa",
        },
        attribute_CITY2_value: {
          label: "Città estera",
        },
        attribute_ZIPC_value: {
          label: "CAP",
        },
        attribute_NOR_value: {
          label: "Nazione di residenza",
        },
        attribute_NOR2_value: {
          label: "Nazione di residenza estera",
        },
        city: {
          label: "Città",
        },
        domicilio: {
          label: "Indirizzo",
        },
      },
      counterpart: {
        attribute_FULN: {
          label: "Nominativo",
        },
        attribute_CPRGP: {
          label: "Targa controparte",
        },
        attribute_CPINS: {
          label: "Compagnia controparte",
        },
        attribute_CPVEH: {
          label: "Veicolo controparte",
        },
      },
      direct_debit: {
        setup_at: {
          label: "Data istanziamento SDD",
        },
        bank_account_id: {
          label: "Banca",
        },
        download_xml: {
          label: "Download",
        },
        id: {
          label: "ID Flusso",
        },
        insurer_id: {
          label: "Compagnia assicuratrice",
        },
        payment_procedure_count: {
          label: "Numero quietanze nel flusso",
        },
      },
      document: {
        created_at: {
          label: "Data creazione",
        },
        download: {
          label: "Scarica documento",
        },
        title: {
          label: "Nome documento",
        },
        note: {
          label: "Descrizione documento",
        },
        document_type: {
          label: "Tipo documento",
        },
        source_type: {
          label: "Sorgente documento",
        },
        metadata: {
          label: "Metadati",
        },
        category: {
          label: "Categoria",
        },
      },
      entry_detail: {
        book_entry_id: {
          label: "Mov. Cont.",
        },
        treasury_id: {
          label: "Cassa",
        },
        gross: {
          label: "Lordo",
        },
        detail_date: {
          label: "Data",
        },
      },
      fattutto: {
        active: {
          label: "Abilitato",
        },
        consolidated_at: {
          label: "Data Consolidata",
        },
        entity: {
          label: "Entità",
        },
        entity_code: {
          label: "Codice - Titolo Entità",
        },
        fattutto_transmission_id: {
          label: "ID",
        },
        ledger_code: {
          label: "Codice Partitario",
        },
        ledger_type: {
          label: "Partitario",
        },
        negative_code: {
          label: "Codice flusso negativo",
        },
        transmission_status: {
          label: "Stato",
        },
        code: {
          label: "Codice",
        },
        created_at: {
          label: "Creato il",
        },
        updated_at: {
          label: "Ultimo aggiornamento",
        },
        progress_percentage: {
          label: "% avanzamento",
        },
        records: {
          label: "Trasmessi / In errore / Da trasmettere / Non mappati",
        },
        errors: {
          label: "Errori",
        },
      },
      filters: {
        "byTypology.status_policy": {
          label: "Tipologia",
        },
        "byOccurrence.date": {
          label: "Data accadimento sinistro",
        },
        "byLisapayPaidAt.from": {
          label: "Data pagamento su Lisapay da",
        },
        "byLisapayPaidAt.to": {
          label: "Data pagamento su Lisapay a",
        },
        "byPaidAt.from": {
          label: "Data pagamento su Lisapay da",
        },
        "byPaidAt.to": {
          label: "Data pagamento su Lisapay a",
        },
        bySettled: {
          label: "Definiti/Non definiti",
        },
        byExclusion: {
          label: "Escludi dal ricalcolo provvigionale",
        },
        start: {
          label: "Data da",
        },
        end: {
          label: "Data a",
        },
        "byInsurancePolicy.REPL": {
          label: "Targa veicolo",
        },
        "byAttribute.caption": {
          label: "Descrizione",
        },
        "byAttribute.GDPR": {
          label: "Consenso raccolto",
        },
        "byAttribute.map": {
          label: "Codice Produttore di Compagnia",
          contexts: {
            profile_import_maps_treasury:
              "Codice forma di pagamento di Compagnia",
            profile_import_maps_insurer_participant: "Codice compagnia",
          },
        },
        byImport: {
          label: "Mappato",
        },
        "byAttribute.description": {
          label: "Descrizione",
        },
        "byInsurancePolicy.number": {
          label: "Numero polizza",
        },
        "byInsurancePolicy.id": {
          label: "Numero polizza",
        },
        "byAttribute.referring_at": {
          label: "Anno",
        },
        "byAttribute.codice": {
          label: "Codice",
          contexts: {
            profile_treasury: "Codice cassa",
            profile_cash_reference: "Causale",
          },
        },
        "byAttribute.descrizione": {
          label: "Cassa",
          contexts: {
            profile_cash_reference: "Descrizione",
          },
        },
        "byAttribute.payment_type": {
          label: "Tipo",
        },
        "byAttribute.comment": {
          label: "Commenti",
        },
        "byAttribute.sent": {
          label: "Quietanza già inviata",
        },
        "byAttribute.communication_type": {
          label: "Tipo comunicazioni",
        },
        "byAttribute.status_procedure": {
          label: "Stato",
        },
        configurable_type: {
          label: "Entità",
        },
        code: {
          label: "Codice Fattutto",
        },
        "byBankAccount.id": {
          label: "Banca",
        },
        "byBrokerGroup.id": {
          label: "Agenzia",
        },
        "byAttribute.setup_at._i": {
          label: "Data istanziamento SDD",
        },
        "byCalendar.to._i": {
          label: "Escludi Titoli Q con scadenza a partire dal",
        },
        "byAttribute.to_collect": {
          label: "Incassabile",
        },
        "byAttribute.consolidated": {
          label: "Consolidato",
        },
        "byInsuranceAncillary.to_collect": {
          label: "Incassabile",
        },
        "byInsuranceAncillary.consolidated": {
          label: "Consolidato",
        },
        "byAttribute.is_selected": {
          label: "Selezionato per l'invio",
        },
        "byAttribute.modified": {
          label: "Quietanze modificate",
        },
        byBankAccount: {
          label: "Contraenti con più scadenze",
          contexts: {
            insurance_payments: "SEPA SDD",
          },
        },
        byRelations: {
          label: "SEPA SDD",
          contexts: {
            insurance_payments:
              "Contraenti con più scadenze nel periodo selezionato",
          },
        },
        "byCustom.comment.value": {
          label: "Cerca testo nei commenti",
        },
        "byCustom.selected": {
          label: "Mostra solo selezionate (per invio)",
        },
        "byClaimParty.title": {
          label: "Nominativo",
          contexts: {
            claims: "Nominativo controparte",
          },
        },
        "byAttribute.error_code": {
          label: "Anomalia / Stato",
        },
        "byClaimParty.status": {
          label: "Tipologia reclamante",
        },
        "byClaimParty.CPRGP": {
          label: "Targa controparte",
        },
        "byAttribute.place": {
          label: "Luogo",
        },
        byTaskable: {
          label: "Tipo nota",
        },
        "byAttribute.template_name": {
          label: "Nome template",
        },
        "byAttribute.username": {
          label: "Nome utente",
        },
        "byAttribute.email": {
          label: "Email",
        },
        "byAttribute.role": {
          label: "Ruolo",
        },
        "byAttribute.title": {
          label: "Descrizione",
          contexts: {
            documents_registries: "Nome documento",
            documents_insurance_policies: "Nome documento",
            documents_no_match: "Nome documento",
            companies_products_insurers: "Compagnia",
            companies_products_insurance_risks: "Titolo del prodotto",
            companies_products_breakdowns: "Scorporo",
            companies_products_mandate_codes: "Descrizione mandato",
            treasuries: "Forma di pagamento",
            profile_various_accountings: "Movimento vario",
            profile_brokers: "Nominativo",
            profile_insurer_participants: "Ragione Sociale Intermediario Coass",
            profile_custom_attributes: "Nome campo",
          },
        },
        "byAttribute.status_payment": {
          label: "Stato",
        },
        "byRegistry.id": {
          label: "Anagrafica",
          contexts: {
            book_entries_deferred: "Contraente",
          },
        },
        "byRegistry.SURN": {
          label: "Cognome",
        },
        "byRegistry.NAME": {
          label: "Nome",
        },
        "byRegistry.CREG": {
          label: "Partita IVA",
        },
        "byRegistry.status_registry": {
          label: "Tipo anagrafica",
        },
        "byAttribute.payment_splitting": {
          label: "Frazionamento",
        },
        "byInsurancePolicy.payment_splitting": {
          label: "Frazionamento",
        },
        byRelatedTasks: {
          label: "Quietanze con note associate",
        },
        byLastInstallment: {
          label: "Scadenza",
        },
        "byInsuranceAncillary.status_ancillary": {
          label: "Stato pagamento",
        },
        "byInsurer.id": {
          label: "Compagnia",
        },
        "byInsurancePolicy.CONV": {
          label: "Convenzioni",
        },
        "byCustom.CREG.value": {
          label: "Partita IVA",
        },
        "byCustom.BCONS.value": {
          label: "Consulente",
        },
        "byCommunicationDetail.is_discarded": {
          label: "Scartate",
        },
        "byAttribute.number": {
          label: "Numero",
          contexts: {
            claims: "Numero sinistro",
          },
        },
        "byAttribute.REPL": {
          label: "Targa",
        },
        "byAttribute.BUID": {
          label: "Codice Univoco Lisaweb",
          contexts: {
            profile_brokers: "Codice",
          },
        },
        "byAttribute.code_importer": {
          label: "Codice Compagnia",
        },
        "byAttribute.title_importer": {
          label: "Compagnia Rappresentata",
        },
        "byAttribute.NINO": {
          label: "Codice Fiscale",
        },
        "byAttribute.CREG": {
          label: "Partita IVA",
        },
        "byAttribute.CLI": {
          label: "Cliente",
        },
        "byAttribute.SUP": {
          label: "Fornitore",
        },
        "byAttribute.SURN": {
          label: "Cognome",
        },
        "byAttribute.PROF": {
          label: "Professione",
        },
        "byAttribute.NAME": {
          label: "Nome",
        },
        "byProvince.id": {
          label: "Provincia",
        },
        "byRiskType.id": {
          label: "Tipo",
        },
        "byRiskBranch.id": {
          label: "Ramo",
        },
        "byInsuranceRisk.id": {
          label: "Prodotto",
        },
        "byCustom.title.value": {
          label: "Nominativo",
          contexts: {
            registry_groups: "Descrizione",
            insurance_policies: "Descrizione prodotto",
            various_accountings: "Descrizione",
          },
        },
        "byCustom.number.value": {
          label: "Numero polizza",
        },
        "byAttribute.status_policy": {
          label: "Status Polizza",
        },
        transmission_status: {
          label: "Status",
        },
        least_one_to_go: {
          label: "Con registrazioni da trasmettere",
        },
        "byExpiration.from": {
          label: "Data Scadenza dal",
        },
        date_from: {
          label: "Data Consolidata dal",
        },
        date_to: {
          label: "Data Consolidata al",
        },
        "byCoverage.from": {
          label: "Data Scadenza dal",
          contexts: {
            insurance_policies: "Data Copertura dal",
          },
        },
        "byCoverage.to": {
          label: "Data Scadenza al",
          contexts: {
            insurance_policies: "Data Copertura al",
          },
        },
        "byFrom.from": {
          label: "Data iniziale dal",
        },
        "byFrom.to": {
          label: "Data iniziale al",
        },
        "byTo.from": {
          label: "Data finale dal",
        },
        "byTo.to": {
          label: "Data finale al",
        },
        "byExpiration.to": {
          label: "Data Scadenza al",
        },
        "byAttribute.is_collected": {
          label: "Incassato",
        },
        "byAttribute.id": {
          label: "ID Rendiconto",
          contexts: {
            communication_procedures: "ID procedura",
          },
        },
        "byStocastico.date": {
          label: "Data di riferimento per titoli arretrati",
        },
        "byReduced.after_deferred": {
          label: "Data Recupero dal",
        },
        "byReduced.before_deferred": {
          label: "Data Recupero al",
        },
        "byStocastico.status": {
          label: "Condizione titoli",
        },
        "byInsurancePayment.comment": {
          label: "Commento QT",
        },
        "byCollaborator.id": {
          label: "Collaborazioni",
        },
        "byAttribute.mandate_code_id": {
          label: "Codice Mandato",
        },
        "byAttribute.status_ancillary": {
          label: "Stato titoli",
        },
        "byAttribute.upselling": {
          label: "Upselling",
        },
        "byAttribute.lisapay_paid": {
          label: "Stato Lisapay",
        },
        "byAttribute.paid": {
          label: "Stato Lisapay",
        },
        "byValidity.from": {
          label: "Data Decorrenza dal",
        },
        "byValidity.to": {
          label: "Data Decorrenza al",
        },
        "byIssue.from": {
          label: "Data Emissione dal",
        },
        "byIssue.to": {
          label: "Data Emissione al",
        },
        "bySuspension.from": {
          label: "Data Sospensione dal",
        },
        "bySuspension.to": {
          label: "Data Sospensione al",
        },
        "byCancellation.from": {
          label: "Data Storno dal",
        },
        "byCancellation.to": {
          label: "Data Storno al",
        },
        "byCalendar.from": {
          label: "Data Registrazione dal",
          contexts: {
            insurance_ancillaries: "Data Effetto dal",
            book_entries_deposited: "Periodo registrazione acconto dal",
            unsolved_payments: "Data",
            various_accountings: "Da",
            insurance_payments: "Periodo da",
            communication_procedures: "Creazione da",
            sepa_payment_procedures: "Periodo da",
            generated_reports: "Data creazione da",
          },
        },
        "byCalendar.to": {
          label: "Data Registrazione al",
          contexts: {
            insurance_ancillaries: "Data Effetto al",
            book_entries_deposited: "Periodo registrazione acconto al",
            various_accountings: "A",
            insurance_payments: "Periodo a",
            communication_procedures: "Creazione a",
            sepa_payment_procedures: "Periodo a",
            generated_reports: "Data creazione a",
          },
        },
        "byDelayUntil.from": {
          label: "Data ultimo giorno dal",
        },
        "byDelayUntil.to": {
          label: "Data ultimo giorno al",
        },
        "byReduced.before_recovery": {
          label: "Data Recupero al",
          contexts: {
            book_entries_deposited: "Periodo recupero acconto al",
          },
        },
        "byReduced.after_recovery": {
          label: "Data Recupero dal",
          contexts: {
            book_entries_deposited: "Periodo recupero acconto dal",
          },
        },
        "byEffectiveness.from": {
          label: "Data Effetto dal",
          contexts: {
            agency_books: "Data valuta dal",
          },
        },
        "byEffectiveness.to": {
          label: "Data Effetto al",
          contexts: {
            agency_books: "Data valuta al",
          },
        },
        "byAttribute.imported_at": {
          label: "Data Foglio Cassa",
        },
        "byPaymentReference.id": {
          label: "Causali",
        },
        "byAttribute.sheet_date": {
          label: "Data Importazione",
        },
        "byDirectDebit.id": {
          label: "ID flusso",
        },
        "byRegistryThroughPolicy.title": {
          label: "Nominativo",
        },
        "byRegistryThroughPolicy.NINO": {
          label: "Codice fiscale",
        },
        "byRegistryThroughPolicy.CREG": {
          label: "Partita IVA",
        },
        "byRegistry.title": {
          label: "Nominativo",
          contexts: {
            sepa_payment_procedures: "Contraente",
          },
        },
        "byAttribute.exclusion_type": {
          label: "Modalità di esclusione",
        },
        "byRegistry.NINO": {
          label: "Codice fiscale",
        },
        "byAttribute.code": {
          label: "Tipo titoli",
          contexts: {
            payment_references: "Codice causale",
            bank_accounts: "Codice impresa mittente SIA",
            companies_products_insurers: "Codice prodotto",
            companies_products_insurance_risks: "Codice prodotto",
            profile_insurer_participants: "Codice Agenzia",
            profile_book_tags: "Codice",
          },
        },
        "byAttribute.BONA": {
          label: "Polizze soggette a regolazione premio",
        },
        "byAttribute.INDX": {
          label: "Polizze indicizzate",
        },
        "byAddressBook.PHON": {
          label: "Telefono",
        },
        "byAddressBook.CELL": {
          label: "Cellulare",
        },
        "byAddressBook.FAX": {
          label: "Fax",
        },
        "byAddressBook.MAIL": {
          label: "Email",
        },
        "byTask.task_type": {
          label: "Polizze con note",
          contexts: {
            registries: "Note",
            insurance_policies: "Note",
          },
        },
        "byRegistryGroup.code": {
          label: "Gruppo Anagrafico",
        },
        byCommunicationChannel: {
          label: "Canale di Comunicazione",
        },
        byEmptyContact: {
          label: "Recapito primario mancante",
        },
        "byCustom.CUST1.value": {
          label: "IBAN",
          contexts: {
            registries: "CODICE ISS",
          },
        },
        "byCustom.CUST2.value": {
          label: "CONV ZSAT",
          contexts: {
            registries: "CODICE COE",
          },
        },
        "byCustom.CUST4": {
          label: "Banca Sella",
        },
        "byCustom.lisapay_paid_at.value": {
          label: "Data pagamento su Lisapay",
        },
        "byCustom.paid_at.value": {
          label: "Data pagamento su Lisapay",
        },
        "byAttribute.CUST3": {
          label: "Vincolo",
        },
        "byAttribute.CNAM": {
          label: "Ragione Sociale",
        },
        "byAttribute.status_registry": {
          label: "Tipo Cliente",
        },
        "byCorrespondence.CITY": {
          label: "Comune",
        },
        "byCorrespondence.ZIPC": {
          label: "CAP",
        },
        "byInsurerParticipant.id": {
          label: "Agenzia coassicuratrice",
        },
        "byCorrespondence.ADDR": {
          label: "Indirizzo",
        },
        "byCustom.ADDR.value": {
          label: "Indirizzo",
        },
        "byAttribute.display": {
          label: "Codice",
          contexts: {
            companies_products_insurers: "Codice compagnia",
            treasuries: "Codice forma di pagamento",
            profile_various_accountings: "Codice movimento vario",
          },
        },
        "byAttribute.abi": {
          label: "Codice ABI",
        },
        "byCustom.code.value": {
          label: "Codice Gruppo",
        },
        "byCustom.description.value": {
          label: "Note",
          contexts: {
            insurance_payments: "Cerca testo nelle note",
          },
        },
        "byCurrency.from": {
          label: "Premio lordo da",
        },
        "byCurrency.to": {
          label: "Premio lordo a",
        },
        "byNet.from": {
          label: "Premio netto da",
        },
        "byNet.to": {
          label: "Premio netto a",
        },
        status: {
          label: "Stato",
        },
        type: {
          label: "Tipo",
        },
        title: {
          label: "Titolo",
        },
        province: {
          label: "Provincia",
        },
        byManual: {
          label: "Anagrafiche Lisaweb",
        },
        "byInsuranceStatus.value": {
          label: "Stato portafoglio",
        },
        "byInsurancePolicy.sharing_type": {
          label: "Delega",
        },
        "byAttribute.note": {
          label: "Descrizione documento",
        },
        "byAttribute.metadata": {
          label: "Metadati",
        },
        "byAttribute.document_type": {
          label: "Tipologia documento",
        },
        "byBroker.id": {
          label: "Produttore",
          contexts: {
            accounting_prod_salesmen: "Produttore",
            lisapay_insurance_ancillary: "Produttore",
          },
        },
        "byActiveBroker.id": {
          label: "Considera solo polizze attive",
        },
        "byAttribute.registered": {
          label: "Registrato in compagnia",
        },
        "byCommissionApplied.id": {
          label: "Produttore",
        },
        "byBrokerEnhanced.salesmen": {
          label: "Produttore",
        },
        produttore: {
          label: "Produttore",
        },
        descrizione: {
          label: "Descrizione",
        },
        a_partire_dal: {
          label: "Dal",
        },
        fino_al: {
          label: "Al",
          contexts: {
            bank_statement: "Saldo conto al",
          },
        },
        foglio_cassa_compagnia: {
          label: "Foglio Cassa Compagnia",
        },
        cassa_agenzia: {
          label: "Controllo di Cassa",
        },
        "byBrokerStatement.id": {
          label: "Stato",
          contexts: {
            book_entries: "Stato rendicontale",
          },
        },
        "byReport.code": {
          label: "Report",
        },
        "byUser.username": {
          label: "Nome utente",
        },
        stato: {
          label: "Stato",
        },
        conto: {
          label: "Conto",
        },
        compagnia: {
          label: "Compagnia",
        },
        recipient: {
          label: "Destinatario",
          contexts: {
            lisacomunica_logs: "Recapito destinatario",
          },
        },
        registry_name: {
          label: "Anagrafica destinatario",
          contexts: {
            lisacomunica_logs: "Nominativo destinatario",
          },
        },
        procedure_id: {
          label: "ID procedura",
        },
        data_registrazione_inizio: {
          label: "Data Apertura dal",
          contexts: {
            cash_entries_default: "Data da",
          },
        },
        data_registrazione_fine: {
          label: "Data Apertura al",
          contexts: {
            cash_entries_default: "Data a",
          },
        },
        data_recupero_inizio: {
          label: "Data Recupero al",
        },
        data_recupero_fine: {
          label: "Data Recupero al",
        },
        "byBrokerEnhanced.cooperators": {
          label: "Collaborazioni",
        },
        "byTreasury.id": {
          label: "Forme di pagamento",
        },
        "byReduced.treasury_deferred": {
          label: "Modalità recupero sospeso",
        },
        "byReduced.treasury_deposit": {
          label: "Modalità recupero acconto",
        },
        "byBookTag.id": {
          label: "Codice documento",
        },
        causale: {
          label: "Causale",
        },
        "byVariousAccounting.id": {
          label: "Codice causale",
        },
        "byTask.description": {
          label: "Nota",
        },
        byStatementAnomaly: {
          label: "Anomalie provvigionali",
        },
        "byAttribute.agencybook_type": {
          label: "Tipologia Movimento",
        },
        attribute_type: {
          label: "Tipologia Anagrafica",
        },
        byDeferred: {
          label: "Mostra sospesi",
        },
        byDeposited: {
          label: "Mostra acconti",
        },
        "bySector.id": {
          label: "Comparti",
        },
      },
      form: {
        multiselect_no_options: {
          label: "Nessuna opzione disponibile",
        },
        multiselect_no_results: {
          label: "Nessuna opzione trovata per il testo ricercato",
        },
        multiselect_selected: {
          label: "Selezionato",
        },
      },
      generated_report: {
        code: {
          label: "Codice Report",
        },
        formatted_title: {
          label: "Titolo Report",
        },
        format: {
          label: "Formato",
        },
        status_report: {
          label: "Stato Report",
        },
        is_ready: {
          label: "Pronto",
        },
        download: {
          label: "Scarica Documenti",
        },
      },
      import_detail: {
        code: {
          label: "Codice",
        },
        error: {
          label: "Errore",
        },
        is_error: {
          label: "Rifiutato",
        },
        title: {
          label: "Gruppo",
        },
      },
      import_log: {
        code: {
          label: "Codice importazione",
        },
        created_at: {
          label: "Data creazione",
        },
        details: {
          label: "Dettagli",
        },
        failed: {
          label: "In errore",
        },
        group: {
          label: "Gruppo",
        },
        insurer: {
          label: "Importatore",
        },
        last_update: {
          label: "Data ultima modifica",
        },
        parsed: {
          label: "Analizzato",
        },
        status: {
          label: "Stato importazione",
        },
        status_import_log: {
          label: "Stato importazione",
        },
        status_broker_statement_log: {
          label: "Stato invio",
        },
        total: {
          label: "Totale",
        },
        type_description: {
          label: "Tipo",
        },
      },
      import_map: {
        map: {
          label: "Mappatura",
        },
        insurer_id: {
          label: "Compagnia",
        },
      },
      insurance_payment: {
        gross_premium: {
          label: "Premio",
        },
        number: {
          label: "Polizza di riferimento",
        },
        comment: {
          label: "Commento",
        },
        status_payment: {
          label: "Stato",
        },
        payment_type: {
          label: "Tipo",
        },
        referring_at: {
          label: "Data Scadenza",
        },
        gross: {
          label: "Premio",
        },
        status_policy: {
          label: "Stato polizza",
        },
        cooperator: {
          label: "Collaborazione",
        },
      },
      insurance_policy: {
        title: {
          label: "Denominazione Polizza",
        },
        number: {
          label: "Numero Polizza",
        },
        mandate_code: {
          label: "Codice Mandato",
        },
        insurer_id: {
          label: "Azienda",
        },
        status_policy: {
          label: "Stato",
        },
        old_policy: {
          label: "Polizza sostituita",
        },
        new_policies: {
          label: "Polizze sostituenti",
        },
        covered_at: {
          label: "Data Copertura",
        },
        effective_at: {
          label: "Data Decorrenza",
        },
        suspended_at: {
          label: "Data Sospensione",
        },
        expired_at: {
          label: "Data Scadenza",
        },
        gross_premium: {
          label: "Lordo rata",
        },
        total_gross: {
          label: "Lordo Annuo",
        },
        gross_payment_splitting: {
          label: "Lordo Annuo",
        },
        net_premium: {
          label: "Premio netto",
        },
        tax_premium: {
          label: "Imposte",
        },
        payment_splitting: {
          label: "Fraz.",
        },
        attribute_BRAN_value: {
          label: "Marca",
        },
        attribute_CANIA_value: {
          label: "Codice Classe ANIA",
        },
        attribute_KWHP_value: {
          label: "Kilowatt potenza",
        },
        attribute_LESC_value: {
          label: "Settore Legislativo",
        },
        attribute_MODL_value: {
          label: "Modello",
        },
        attribute_NCLBC_value: {
          label: "Classe di merito compagnia",
        },
        attribute_NCLB_value: {
          label: "Classe di merito",
        },
        attribute_OVALU_value: {
          label: "Valore Optional",
        },
        attribute_POW_value: {
          label: "Tipo Alimentazione",
        },
        attribute_QMTR_value: {
          label: "Quintali Motrice Autocarri",
        },
        attribute_QTTR_value: {
          label: "Quintali Rimorchio Autocarri",
        },
        attribute_REGM_value: {
          label: "Mese registrazione",
        },
        attribute_REGY_value: {
          label: "Anno registrazione",
        },
        attribute_REPL_value: {
          label: "Targa",
        },
        attribute_SANIA_value: {
          label: "Codice Settore ANIA",
        },
        attribute_SETP_value: {
          label: "Allestimento",
        },
        attribute_STNO_value: {
          label: "Numero posti",
        },
        attribute_STTL_value: {
          label: "Numero posti complessivi",
        },
        attribute_STTR_value: {
          label: "Numero posti rimorchio",
        },
        attribute_TXHP_value: {
          label: "Cavalli Fiscali",
        },
        attribute_UANIA_value: {
          label: "Codice Uso ANIA",
        },
        attribute_VALU_value: {
          label: "Valore Commerciale",
        },
        attribute_VEHT_value: {
          label: "Tipologia veicolo",
        },
        attribute_WEIG_value: {
          label: "Peso complessivo",
        },
        attribute_REVD_value: {
          label: "Data storno o rescindibilità",
        },
        attribute_RENW_value: {
          label: "Tacito Rinnovo",
        },
        attribute_INDX_value: {
          label: "Indicizzata",
        },
        attribute_CONV_value: {
          label: "Convenzione",
        },
        attribute_LNOT_value: {
          label: "Disdettata",
        },
        attribute_BONA_value: {
          label: "Regolazione Premio",
        },
        attribute_RCA_value: {
          label: "RCA",
        },
        attribute_INCFUR_value: {
          label: "INCENDIO/FURTO",
        },
        attribute_KASK_value: {
          label: "KASKO",
        },
        attribute_EKASK_value: {
          label: "EASYKASKO",
        },
        attribute_CRCA_value: {
          label: "COMPLEMENTARE RCA",
        },
        attribute_CARD_value: {
          label: "COMPLEMENTARE ARD",
        },
        attribute_PPARD_value: {
          label: "PERDITE PECUNIARIE DA ARD",
        },
        attribute_ENAT_value: {
          label: "EVENTI NATURALI",
        },
        attribute_ESOC_value: {
          label: "EVENTI SOCIO-POLITICI",
        },
        attribute_CRI_value: {
          label: "CRISTALLI",
        },
        attribute_RPAT_value: {
          label: "RITIRO PATENTE",
        },
        attribute_ASS_value: {
          label: "ASSISTENZA",
        },
        delay_days: {
          label: "Giorni di mora",
        },
        /* */
        attribute_RCATI_value: {
          label: "TIPOLOGIA",
        },
        attribute_RCABM_value: {
          label: "CLASSE DI MERITO",
        },
        attribute_RCATG_value: {
          label: "TIPO DI GUIDA",
        },
        attribute_RCASC_value: {
          label: "SCONTO",
        },
        attribute_RCAMAX_value: {
          label: "MASSIMALE",
        },
        /* */
        attribute_INCSC_value: {
          label: "SCONTO INCENDIO",
        },
        attribute_INCSCIM_value: {
          label: "SCONTO INCENDIO IMPORTO",
        },
        attribute_INCTA_value: {
          label: "TASSO INCENDIO",
        },
        attribute_INCSCO_value: {
          label: "SCOPERTO INCENDIO",
        },
        attribute_INCFURSC_value: {
          label: "SCONTO INCENDIO E FURTO",
        },
        attribute_INCFUSCI_value: {
          label: "SCONTO INCENDIO E FURTO IMPORTO",
        },
        attribute_INCFURTA_value: {
          label: "TASSO INCENDIO E FURTO",
        },
        attribute_INCFURSO_value: {
          label: "SCOPERTO INCENDIO E FURTO",
        },
        /* */
        attribute_KASKFOR_value: {
          label: "FORMA GARANZIA",
        },
        attribute_KASKTA_value: {
          label: "TASSO",
        },
        attribute_KASKSCO_value: {
          label: "SCOPERTO",
        },
        attribute_KASKSC_value: {
          label: "SCONTO",
        },
        /* */
        attribute_EKASKMXR_value: {
          label: "MASSIMO RISARCIMENTO",
        },
        attribute_EKASKTIF_value: {
          label: "TIPO FRANCHIGIA",
        },
        attribute_EKASKFOF_value: {
          label: "FORMA FRANCHIGIA",
        },
        attribute_EKASKIMF_value: {
          label: "IMPORTO FRANCHIGLIA",
        },
        /* */
        attribute_CRCATA_value: {
          label: "TASSO",
        },
        attribute_CRCASC_value: {
          label: "SCONTO",
        },
        /* */
        attribute_CARDTA_value: {
          label: "TASSO",
        },
        attribute_CARDSC_value: {
          label: "SCONTO",
        },
        /* */
        attribute_ENATTA_value: {
          label: "TASSO",
        },
        attribute_ENATSC_value: {
          label: "SCONTO",
        },
        attribute_ENATSCO_value: {
          label: "SCOPERTO",
        },
        /* */
        attribute_ESOCTA_value: {
          label: "TASSO",
        },
        attribute_ESOCSC_value: {
          label: "SCONTO",
        },
        attribute_ESOCSCO_value: {
          label: "SCOPERTO",
        },
        /* */
        attribute_CRITA_value: {
          label: "TASSO",
        },
        attribute_CRISC_value: {
          label: "SCONTO",
        },
        attribute_CRISCO_value: {
          label: "SCOPERTO",
        },
        attribute_RPATFO_value: {
          label: "RIRITO PATENTE FORMA",
        },
        attribute_TUTGFO_value: {
          label: "TUTELA GIUDIZIARIA FORMA",
        },
        attribute_ASSFO_value: {
          label: "ASSITENZA FORMA",
        },
        attribute_INFCOFO_value: {
          label: "INFORTUNI CONDUCENTE FORMA",
        },
        /* */
      },
      insurance_ancillary: {
        ancillary_code: {
          label: "Quietanza",
        },
        title: {
          label: "Descrizione",
        },
        book_date: {
          label: "Data Foglio Cassa",
        },
        code: {
          label: "Tipo titolo",
        },
        effective_at: {
          label: "Data Effetto",
        },
        insurance_policy_id: {
          label: "Polizza",
        },
        lisapay_paid: {
          label: "Stato Lisapay",
        },
        lisapay_paid_at: {
          label: "Data pagamento su Lisapay",
        },
        registered: {
          label: "Registrato in Compagnia",
        },
        registered_at: {
          label: "Data registrazione in Compagnia",
        },
        upselling: {
          label: "Upselling",
        },
        to_collect: {
          label: "Incassabile",
        },
        consolidated: {
          label: "Consolidato",
        },
        cooperators: {
          label: "Polizza in collaborazione",
        },
        collected: {
          label: "Incassato",
        },
        charge_error: {
          label: "Errore registrazione",
        },
        broker_id: {
          label: "Produttore",
        },
        net: {
          label: "Netto",
        },
        tax: {
          label: "Tasse",
        },
        gross: {
          label: "Lordo",
        },
        fee_gross: {
          label: "Di cui Diritti",
        },
        delay_days: {
          label: "Giorni di mora",
        },
        delay_until: {
          label: "Ultimo Giorno",
        },
        status_ancillary: {
          label: "Stato Titolo",
        },
      },
      insurance_risk: {
        title: {
          label: "Rischio / Prodotto",
        },
        code: {
          label: "Codice Rischio",
        },
        custom_code: {
          label: "Codice",
        },
        insurer_id: {
          label: "Compagnia",
        },
        risk_branch_id: {
          label: "Ramo",
        },
        risk_type: {
          label: "Codice Rischio",
        },
        delay_days: {
          label: "Giorni di mora",
        },
      },
      insurer: {
        title: {
          label: "Descrizione Compagnia",
        },
        code: {
          label: "Codice Produttore di Compagnia",
        },
        payment: {
          label: "Codice forma di pagamento di Compagnia",
        },
        importer_id: {
          label: "Importatore",
        },
      },
      job_spool: {
        status_jobspool: {
          label: "Stato",
        },
        last_update: {
          label: "Data Creazione",
        },
      },
      insurer_participant: {
        title: {
          label: "Ragione Sociale Intermediario Coass",
        },
        code: {
          label: "Codice Agenzia",
        },
        title_importer: {
          label: "Compagnia Rappresentata",
        },
        code_importer: {
          label: "Codice Compagnia",
        },
      },
      mandate_code: {
        title: {
          label: "Descrizione Mandato",
        },
        code: {
          label: "Codice Mandato",
        },
        is_expired: {
          label: "Disabilitato",
        },
      },
      note_template: {
        template_name: {
          label: "Nome template",
        },
        taskable_type: {
          label: "Tipo nota",
        },
        title: {
          label: "Titolo nota",
        },
        description: {
          label: "Testo nota",
        },
      },
      payment_reference: {
        title: {
          label: "Titolo",
        },
        code: {
          label: "Codice Causale",
        },
        caption: {
          label: "Descrizione",
        },
      },
      payment_procedure: {
        direct_debit_id: {
          label: "ID Flusso",
        },
        exclusion_type: {
          label: "Modalità di esclusione",
        },
        first_attempt: {
          label: "Primo invio",
        },
        gross: {
          label: "Lordo",
        },
        iban: {
          label: "Codice IBAN",
        },
        insurer: {
          label: "Compagnia",
        },
        identifier: {
          label: "Creditor identifier",
        },
        policy: {
          label: "Polizza",
        },
        processing_at: {
          label: "Data di esecuzione mandato",
        },
        risk: {
          label: "Prodotto",
        },
      },
      rebate: {
        title: {
          label: "Importo Abbuono",
        },
      },
      registry: {
        pk: {
          label: "Identificativo primario",
        },
        sk: {
          label: "Identificativo secondario",
        },
        insurer_id: {
          label: "Assicuratore",
        },
        status_registry: {
          label: "Tipo",
        },
        attribute_TITL_value: {
          label: "Titolo",
        },
        title: {
          label: "Descrizione",
        },
        attribute_SEX_value: {
          label: "Sesso",
        },
        attribute_NAME_value: {
          label: "Nome",
        },
        attribute_SURN_value: {
          label: "Cognome",
        },
        attribute_CNAM_value: {
          label: "Ragione sociale",
        },
        attribute_NINO_value: {
          label: "Codice Fiscale",
        },
        attribute_CREG_value: {
          label: "Partita IVA",
        },
        attribute_LIAB_value: {
          label: "Forma societaria",
        },
        attribute_MARS_value: {
          label: "Stato civile",
        },
        attribute_PROF_value: {
          label: "Professione / Attività",
        },
        attribute_DOB_value: {
          label: "Data nascita",
        },
        attribute_POB_value: {
          label: "Luogo nascita",
        },
        attribute_POB2_value: {
          label: "Luogo nascita estero",
        },
        attribute_NOB_value: {
          label: "Nazione nascita",
        },
        attribute_NOB2_value: {
          label: "Nazione di nascita estera",
        },
        attribute_TREG_value: {
          label: "Identificativo temporaneo",
        },
        attribute_CHAN_value: {
          label: "Canale preferito",
        },
        attribute_GDPR_value: {
          label: "Consenso Raccolto",
        },
        attribute_DOCT_value: {
          label: "Tipo documento",
        },
        attribute_DOCN_value: {
          label: "N.ro documento",
        },
        attribute_DOCS_value: {
          label: "Data emissione",
        },
        attribute_DOCX_value: {
          label: "Scadenza",
        },
        attribute_ISPL_value: {
          label: "Località emissione",
        },
        relation: {
          label: "Relazioni",
        },
      },
      registry_group: {
        title: {
          label: "Descrizione",
        },
        is_coordinator: {
          label: "Capogruppo",
        },
        code: {
          label: "Codice",
        },
      },
      relation: {
        registry: {
          label: "Nome/Cognome/Rag.sociale",
        },
      },
      report: {
        code: {
          label: "Codice Report",
        },
        title: {
          label: "Descrizione",
        },
        pdf: {
          label: "PDF",
        },
        csv: {
          label: "CSV",
        },
      },
      risk_branch: {
        title: {
          label: "Ramo",
        },
        code: {
          label: "Codice Ramo",
        },
      },
      sector: {
        title: {
          label: "Comparto",
        },
        display: {
          label: "Codice",
        },
        is_hidden: {
          label: "Nascosto",
        },
        is_system: {
          label: "Sistema",
        },
        is_abstract: {
          label: "Astratto",
        },
        is_agency: {
          label: "Per Contabilità d'Agenzia",
        },
        initial_balance: {
          label: "Saldo Iniziale",
        },
        initial_balance_date: {
          label: "Data Inizio Saldo",
        },
        entry_tot: {
          label: "Saldo",
        },
      },
      task: {
        title: {
          label: "Titolo",
        },
        description: {
          label: "Descrizione",
        },
        task_type: {
          label: "Tipologia",
        },
        inheritance: {
          label: "Ereditarietà",
        },
        is_public: {
          label: "È Pubblico",
        },
        created_at: {
          label: "Data Creazione",
        },
        owner: {
          label: "Creato da",
        },
        started_at: {
          label: "Data inizio",
        },
        ended_at: {
          label: "Data fine",
        },
        expired_at: {
          label: "Data scadenza",
        },
        users: {
          label: "Condividi con",
        },
        taskable: {
          label: "Nome relazione",
        },
        taskable_id: {
          label: "ID relazione",
        },
        status_task: {
          label: "Stato",
        },
        polizza_sostituita: {
          label: "Polizza Sostituita",
        },
        polizza_sostituente: {
          label: "Polizza Sostituente",
        },
      },
      treasury: {
        title: {
          label: "Forma di pagamento Lisaweb",
        },
        code: {
          label: "Codice",
        },
        info: {
          label: "Informazione",
        },
        sector_id: {
          label: "Comparto",
        },
        status_treasury: {
          label: "Tipo",
        },
      },
      user: {
        username: {
          label: "Nome Utente",
        },
        email: {
          label: "Email",
        },
        role: {
          label: "Ruolo",
        },
        is_limited: {
          label: "Nascondi Provvigioni di Agenzia",
        },
        title: {
          label: "Descrizione",
        },
      },
      unsolved_payment: {
        title: {
          label: "Descrizione",
        },
        status_payment: {
          label: "Stato",
        },
        registry_id: {
          label: "Contraente",
        },
        amount: {
          label: "Ammontare",
        },
        unsolved_at: {
          label: "Data Decorrenza",
        },
      },
      various_accounting: {
        title: {
          label: "Descrizione",
        },
        description: {
          label: "Definizione",
        },
        code: {
          label: "Codice Causale",
        },
        is_anticipated: {
          label: "È anticipato",
        },
        is_system: {
          label: "È per sistema",
        },
        status_broker: {
          label: "Status su produttore",
        },
        status_registry: {
          label: "Status su anagrafica",
        },
        status_insurer: {
          label: "Status su compagnia",
        },
        value_type: {
          label: "Tipo Valore",
        },
      },
    },
    // index filters/tables
    address_book: "Contatti",
    advance_payment: "Acconto",
    advance_payments: "Acconti",
    agency_book: "Contabilità Agenzia",
    agency_contact: "Contatto Agenzia",
    agency_gross: "Provv. Agenzia",
    appointment: "Appuntamenti",
    balance_sheet: "Rendiconto",
    book_entry: "Foglio Cassa",
    breakdown: "Scorporo",
    broker_statement: "Rendiconto",
    broker_statement_id: "Rendiconto",
    broker_statement_included:
      "Rendicontato nel rendiconto n. §id§ (dal §date_from§ al §date_to§) emesso il §created_date§",
    broker_statement_not_included: "Non Rendicontato",
    broker: "Broker",
    claim_party: "Controparte",
    claim: "Sinistro",
    commission: "Provvigione",
    commissions: "Provvigioni",
    commissions_to_liquidate: "Provvigioni da liquidare",
    consolidated_treasury: "Consolidato",
    contractor: "Contraente",
    cooperator: "Collaborazione",
    cooperators: "Collaboratori",
    correspondence: "Indirizzo",
    country: "Nazione",
    country_ispl: "Nazione emissione",
    covered_at: "Data Copertura",
    created_at: "Data Creazione",
    customer_name: "Nominativo / Ragione Sociale",
    customer: "Cliente",
    deduction: "Ritenuta d'acconto",
    diritto_gross: "Diritti Lordo",
    diritto_net: "Diritti Netto",
    diritto_tax: "Tasse su Diritti",
    document: "Documenti",
    effective_at: "Data Decorrenza",
    entry_detail: "Dettaglio",
    expired_at: "Data Scadenza",
    fees: "Diritti",
    gross: "Lordo",
    gross_coass: "Pr. Lordo Coass",
    grossRow: "Lordo riga",
    import_map: "Mappa Import",
    insurance_ancillaries: "Titoli",
    insurance_ancillary: "Titolo",
    insurance_payment: "Quietanzamento",
    insurance_policies: "Polizze",
    insurance_policy: "Polizza",
    insurance_risk: "Prodotto",
    insurer_accounting: "Contabilità",
    insurer: "Compagnia",
    insurer_participant: "Compagnia Coass",
    invoice: "Fattura",
    invoice_number: "Numero fattura",
    issued_at: "Data Emissione ",
    loading: "Caricamento...",
    make_official_balance_sheet: "Ufficializza rendiconto",
    net: "Netto",
    note: "Note",
    of_which_deferred_to_collect: "Di cui sospesi da incassare",
    of_which_fees: "Di cui diritti",
    of_which_not_taxable: "Di cui non soggette a ritenuta d'acconto",
    of_which_still_available: "Di cui ancora disponibili",
    period: "Periodo",
    primary_group: "Gruppo primario",
    payment_reference: "Riferimento",
    premio_gross: "Premio Lordo",
    premio_gross_fk: "gross_fk",
    premio_net: "Premio Netto",
    premio_tax: "Tasse su Premio",
    premium: "Premio",
    premiums: "Premi",
    premiums_balance: "Saldo premi",
    province: "Provincia",
    province_ispl: "Provincia emissione",
    registry_group: "Gruppo",
    registry_groups: "Gruppi",
    registry: "Anagrafica",
    risk_branch: "Ramo-Rischio",
    salesman: "Produttore",
    salesmen: "Produttori",
    saler_gross: "Provv. Produttore",
    sector: "Comparto",
    sectors: "Comparti",
    summary: "Riepilogo",
    summary_balance_sheet: "Riepilogo Rendiconto",
    surveyor: "Perito",
    task: "Task",
    tax: "Tasse",
    todo: "Attività",
    total: "Totale",
    totals: "Totali",
    total_gross_premium: "Totale Premi",
    total_to_be_invoiced_gross: "Importo da incassare",
    treasury: "Cassa",
    various_accounting: "Movimento Vario",
  },
});

const skipWords = Object.freeze({
  it: [
    "il",
    "lo",
    "la",
    "i",
    "gli",
    "le",
    "un",
    "uno",
    "una",
    "del",
    "dello",
    "della",
    "dei",
    "degli",
    "delle",
    "di",
    "a",
    "da",
    "in",
    "con",
    "su",
    "per",
    "tra",
    "fra",
  ],
});

// TODO use vuex store dictionaries instead of freezed object above
// import store from "@/store";
// const Dictionary = store.state.dictionaries.dicts;

export const getDictionary = (
  field,
  repository,
  context = "",
  locale = "it",
  abbreviate = false,
  extraParams = {},
) => {
  let label = field;
  if (repository) {
    if (
      Dictionary[locale].resources[repository] &&
      Dictionary[locale].resources[repository][field]
    )
      if (repository === "filters") {
        const filter = Dictionary[locale].resources[repository][field];
        // Se esiste un contesto, usa la label associata
        if (filter.contexts && filter.contexts[context]) {
          label = filter.contexts[context];
        } else {
          label = filter.label;
        }
      } else {
        label = abbreviate
          ? makeAbbr(
              removeArticles(
                Dictionary[locale].resources[repository][field].label,
                locale,
              ),
            )
          : Dictionary[locale].resources[repository][field].label;
      }
  } else {
    if (Dictionary[locale][field]) {
      label = abbreviate
        ? makeAbbr(removeArticles(Dictionary[locale][field], locale))
        : Dictionary[locale][field];
    }
  }
  if (extraParams && Object.keys(extraParams).length) {
    Object.keys(extraParams).forEach(
      (el) => (label = label.replace(`§${el}§`, extraParams[el])),
    );
  }
  /* */
  if (repository === "filters" && label === field) return "";
  /* */
  return label;
};

/*
esempio:
str = "I diritti di incasso del produttore";
ret = makeAbbr(removeArticles(str));
> 'Dir.Inc.Pro'
*/

export const makeAbbr = (words, chars = 3, splitBy = " ", joinBy = ".") => {
  return words
    .split(splitBy)
    .map((word) => word[0].toUpperCase() + word.slice(1, chars))
    .join(joinBy);
};

export const removeArticles = (str, locale = "it") => {
  let keep = [];
  let words = str.split(" ");
  // if(words.length <= 1) return ret;
  for (let word of words) {
    if (!skipWords[locale].includes(word.toLowerCase())) {
      keep.push(word);
    }
  }
  return keep.join(" ");
};

export const getDynamicFilterLabel = (name, customFilters) => {
  if (!customFilters?.length) return "";
  const byCustomMatch = name.match(/^byCustom\.(.+?)\.value$/);
  if (byCustomMatch) {
    const cf = customFilters.find((e) => e.key === byCustomMatch[1]);
    if (cf) return cf.label;
  }
  const byAttrMatch = name.match(/^byAttribute\.(.+)$/);
  if (byAttrMatch) {
    const cf = customFilters.find((e) => e.key === byAttrMatch[1]);
    if (cf) return cf.label;
  }
  return "";
};

// module.exports = {
//   default,
// };
